import type { SortDirection } from '@tanstack/react-table';
import { TableHeader } from '@vizit/atoms';
import * as React from 'react';

interface OrganizationTableHeaderProps {
  /**
   * The field currently being sorted
   * @optional
   */
  sortBy?: string;
  /**
   * The current sort direction
   * @optional
   */
  sortDirection?: SortDirection | false;
  /**
   * Callback when a sortable column header is clicked
   * @optional
   */
  onSort?: (field: string) => void;
}

/**
 * Memoized header component for the organization table with sortable columns
 * for Name, Account Type, Created By, and Created At fields.
 *
 * @param props - Sort state and callback props
 */
const OrganizationTableHeader = React.memo((props: OrganizationTableHeaderProps) => {
  const { sortBy, sortDirection, onSort } = props;

  const getSortDirection = (field: string): SortDirection | false => {
    if (sortBy === field && sortDirection) return sortDirection;
    return false;
  };

  return (
    <TableHeader>
      <TableHeader.SortableColumn
        isRowHeader
        className="w-1/6"
        sortDirection={getSortDirection('name')}
        onSort={() => onSort?.('name')}
      >
        Name
      </TableHeader.SortableColumn>
      <TableHeader.SortableColumn
        className="w-1/6"
        sortDirection={getSortDirection('account_type')}
        onSort={() => onSort?.('account_type')}
      >
        Account Type
      </TableHeader.SortableColumn>
      <TableHeader.Column className="w-1/4">ICP Product Categories</TableHeader.Column>
      <TableHeader.SortableColumn
        className="w-1/6"
        sortDirection={getSortDirection('created_by')}
        onSort={() => onSort?.('created_by')}
      >
        Created By
      </TableHeader.SortableColumn>
      <TableHeader.SortableColumn
        className="w-1/6"
        sortDirection={getSortDirection('created_at')}
        onSort={() => onSort?.('created_at')}
      >
        Created At
      </TableHeader.SortableColumn>
      <TableHeader.Column aria-label="Actions" className="w-1/6">
        {' '}
      </TableHeader.Column>
    </TableHeader>
  );
});

export { OrganizationTableHeader };
export type { OrganizationTableHeaderProps };
